import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NopCollectorClass;
function NopCollector() {
  if (NopCollectorClass === VOID) {
    class $ {
      *emit_53hnst_k$(value, $completion) {
        return Unit_instance;
      }
      emit_t92u1f_k$(value, $completion) {
        return this.emit_53hnst_k$(value, $completion);
      }
    }
    initMetadataForObject($, 'NopCollector', VOID, VOID, [FlowCollector()], [1]);
    NopCollectorClass = $;
  }
  return NopCollectorClass;
}
var NopCollector_instance;
function NopCollector_getInstance() {
  return NopCollector_instance;
}
//region block: init
NopCollector_instance = new (NopCollector())();
//endregion
//region block: exports
export {
  NopCollector_instance as NopCollector_instance2794m19vxdmgu,
};
//endregion

//# sourceMappingURL=NopCollector.mjs.map
